import { CommonModule, isPlatformBrowser } from "@angular/common";
import { Component, computed, effect, inject, PLATFORM_ID, signal } from "@angular/core";
import { MatCardContent, MatCardModule } from "@angular/material/card";
import { SalesService } from "../../services/sales-agent.service";
import { AuthService } from "../../../../core/services/auth.service";
import { SalesForm } from "../../models/sales-agent.model";
import { LoaderComponent } from "../../../../shared/general/components/loader/loader.component";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";

@Component({
  selector: 'app-agent-form-record',
  imports: [
    CommonModule,
    MatCardModule,
    MatCardContent,
    MatIconModule,
    MatButtonModule,
    LoaderComponent
  ],
  templateUrl: './agent-form-records.html',
  styleUrl: './agent-form-records.scss',
})
export class AgentFormRecordComponent {
  private salesService = inject(SalesService);
  private auth = inject(AuthService);
  private platformId = inject(PLATFORM_ID);

  forms = signal<SalesForm[]>([]);
  isLoading = signal(true);                    // ← ADD THIS

  // Computed signals remain the same
  termsForm = computed(() => {
    const id = this.auth.userId();
    return this.forms().find(f => f.formType === 'sales' && f.userId === id);
  });

  referralForms = computed(() => {
    const id = this.auth.userId();
    return this.forms().filter(f => f.formType === 'sales' && f.userId !== id);
  });

  listingForms = computed(() => {
    return this.forms().filter(f => f.formType === 'listing');
  });

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      effect(() => {
        const id = this.auth.userId();

        if (id) {
          this.isLoading.set(true);                    // Start loading

          this.salesService.getSalesAgentFormsByUserId(id).subscribe({
            next: (data) => {
              this.forms.set(data ?? []);              // Safe fallback
              this.isLoading.set(false);               // Stop loading
            },
            error: (err) => {
              console.error('Failed to load forms', err);
              this.forms.set([]);
              this.isLoading.set(false);               // Always stop loading on error
            }
          });
        } else {
          this.forms.set([]);
          this.isLoading.set(false);
        }
      });
    }
  }
}